import axios from 'axios'
import { auth } from '@/services'
import store from '@/store'
import router from '@/router'
import * as renewAuthHeaders from '@/helpers/renewAuthHeaders'

const connectionProxy = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  timeout: 10000
})

connectionProxy.interceptors.request.use(async (config) => {
  config.headers = auth.getUserAuthData() || {}
  return config
}, (error) => {
  return Promise.reject(error)
})

connectionProxy.interceptors.response.use(async (response) => {
  if (auth.getUserAuthData()) {
    renewAuthHeaders.renewHeaders(response)
  }

  return response
}, (error) => {
  const handle401 = () => {
    store.dispatch('snackbar/showSnack', 'Sessão expirada.')
    store.dispatch('auth/logout')
    router.push('/login')
  }

  const handleRenewHeaders = () => {
    if (auth.getUserAuthData()) {
      renewAuthHeaders.renewHeaders(error?.response || {})
    }
  }

  error?.response?.status !== 401 ? handleRenewHeaders() : handle401()

  return Promise.reject(error)
})

export default connectionProxy
